import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Event
import event from 'services/event'

// Constant
import { EVENT_LOCATION_CHANGE } from 'constants/events'
import { EVENT_CLOSE_ALL_DROPDOWN } from 'constants/events'

// Components
import BaseDropdown from 'antd/lib/dropdown'

export const Dropdown = ({ children, ...props }) => {
  const [statusVisible, setVisible] = useState(false)

  const onVisibleChange = (e) => {
    setVisible(e)
  }

  const onLocationChange = useCallback(() => {
    setVisible(false)
  }, [])

  const onPopupChange = useCallback(() => {
    setVisible(false)
  }, [])

  useEffect(() => {
    event.on(EVENT_LOCATION_CHANGE, onLocationChange)
    return () => {
      event.off(EVENT_LOCATION_CHANGE, onLocationChange)
    }
  })

  useEffect(() => {
    event.on(EVENT_CLOSE_ALL_DROPDOWN, onPopupChange)
    return () => {
      event.off(EVENT_CLOSE_ALL_DROPDOWN, onPopupChange)
    }
  })
  return (
    <BaseDropdown
      visible={statusVisible}
      onVisibleChange={onVisibleChange}
      {...props}
    >
      {children}
    </BaseDropdown>
  )
}

// Props
Dropdown.propTypes = {
  children: PropTypes.node,
}

Dropdown.defaultProps = {
  children: null,
}

export default Dropdown
